var _rect, _path, _rect2, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0461426,
    width: 88,
    height: 88,
    rx: 6,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.04614C0 2.73243 2.68629 0.0461426 6 0.0461426H82C85.3137 0.0461426 88 2.73243 88 6.04614V18.0461H0V6.04614Z",
    fill: "#8F80F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7.04614,
    width: 39,
    height: 3,
    rx: 1.5,
    fill: "#745EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.0461L0 82.0461C0 85.3598 2.68629 88.0461 6 88.0461H11V18.0461H0Z",
    fill: "#D5E5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.0461426H11H6C2.68629 0.0461426 0 2.73243 0 6.04614L0 18.0461H11V7.04614C11 3.18015 14.134 0.0461426 18 0.0461426Z",
    fill: "#745EF6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 8.54614,
    r: 1.5,
    fill: "#745EF6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 8.54614,
    r: 1.5,
    fill: "#745EF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8935 75.3011H67.1075C72.6707 75.3011 75.9341 69.0421 72.749 64.4804L50.2998 32.3312C47.2419 27.9518 40.7591 27.9518 37.7007 32.3312L15.2515 64.4804C12.0669 69.0421 15.3303 75.3011 20.8935 75.3011Z",
    fill: "#FC4A61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.894 75.3011H20.8935C15.3303 75.3011 12.0669 69.0421 15.2515 64.4804L37.7007 32.3312C40.3753 28.5012 45.6691 28.0207 49.0006 30.8896C48.5226 31.3012 48.0849 31.7817 47.7012 32.3312L25.252 64.4804C22.0674 69.0421 25.3308 75.3011 30.894 75.3011Z",
    fill: "#E3133F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1831 54.4021C41.4331 54.4021 39.1831 52.1569 39.1831 49.4127V29.3921C39.1831 26.6473 41.4331 24.4021 44.1831 24.4021C46.9331 24.4021 49.1831 26.6473 49.1831 29.3921V49.4127C49.1831 52.1569 46.9331 54.4021 44.1831 54.4021Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1831 49.4127C39.1831 52.1569 41.4331 54.4021 44.1831 54.4021C44.8929 54.4021 45.5694 54.2525 46.1826 53.9834C44.421 53.2095 43.1831 51.4486 43.1831 49.4132V29.3926C43.1831 27.3563 44.4215 25.5949 46.1837 24.8213C45.5703 24.5519 44.8934 24.4021 44.1831 24.4021C41.4331 24.4021 39.1831 26.6473 39.1831 29.3921V49.4127Z",
    fill: "#E0F1F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.231 64.4366C49.231 67.1981 46.9923 69.4363 44.231 69.4363C41.4696 69.4363 39.231 67.1981 39.231 64.4366C39.231 61.675 41.4696 59.4363 44.231 59.4363C46.9923 59.4363 49.231 61.675 49.231 64.4366Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2303 59.8521C45.618 59.5846 44.9418 59.4363 44.231 59.4363C41.4696 59.4363 39.231 61.675 39.231 64.4366C39.231 67.1981 41.4696 69.4363 44.231 69.4363C44.9423 69.4363 45.6189 69.2878 46.2315 69.0201C44.4652 68.2488 43.2308 66.4867 43.2308 64.4361C43.2308 62.3859 44.4647 60.6238 46.2303 59.8521Z",
    fill: "#E0F1F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage1);
export default __webpack_public_path__ + "static/media/error_image_1.7bdc7d3c20ea3119c35c62ddc156d9c2.svg";
export { ForwardRef as ReactComponent };